import script from "./NavLink.vue?vue&type=script&setup=true&lang=js"
export * from "./NavLink.vue?vue&type=script&setup=true&lang=js"

import "./NavLink.vue?vue&type=style&index=0&id=0ac5b0dc&lang=scss&scoped=true"

import exportComponent from "/Users/pontiroli/Desktop/Repositories/eni/dist/eni-dist-eni-for-2022-hub-e-longform/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ac5b0dc"]])

export default __exports__